import { isFunction } from "@videojs/utils/predicate";
//#region src/network/credentials-fetch.ts
/**
* Decorate a fetch so every request carries the mode the policy resolves to. The decorated fetch's type is preserved,
* so this wraps the manifest, playlist, and segment fetches alike.
*
* The policy runs per request rather than once at decoration: it mirrors the media element's `crossorigin` attribute,
* which an author can change after the fetch was built. An explicit per-call `credentials` still wins, and a policy
* yielding `undefined` leaves the request at the platform default — `Request` treats an `undefined` init member as
* absent.
*/
function credentialsFetch(baseFetch, policy) {
	if (policy === void 0) return baseFetch;
	const resolve = isFunction(policy) ? policy : () => policy;
	return ((addressable, options) => baseFetch(addressable, {
		credentials: resolve(addressable),
		...options
	}));
}
//#endregion
export { credentialsFetch };

//# sourceMappingURL=credentials-fetch.js.map